(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drb-doctors"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   THE TAB SET
   ============================================================================
   ⚠️ ITS FIRST ACT IS TO HIDE THINGS. Every panel renders visible so that a
   failed bundle leaves three complete profiles rather than three names and
   nothing to trust. Do not move the hiding into the markup to "save a reflow".

   Delegated from the document rather than bound per section, so it survives the
   theme editor re-rendering a section and so two of these on one page cannot
   fight over listeners.
   ============================================================================ */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const select = (list, index, focus) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      /* Only the selected tab is in the tab order. Arrow keys move between them,
         which is what a tablist is supposed to do — leaving all three tabbable
         makes a keyboard user walk the whole set to get past it. */
      tab.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
      if (on && focus) tab.focus();
    });
  };

  /* ==========================================================================
     THE AUTO-CYCLE
     ==========================================================================
     Mike, 2026-09-12: "maybe auto cycle through all 3 doctors every 3-4 seconds
     unless someone clicks on one."

     Mike, 2026-09-12, second pass: "if someone doesn't do anything on it for 15
     seconds it automatically starts cycling again."

     ⚠️ A CLICK NO LONGER STOPS IT FOR GOOD — IT HOLDS IT. That was the original
     behaviour and Mike changed it deliberately, so do not "restore" it. The
     reasoning still holds for the first fifteen seconds: taking a visitor's
     choice back two seconds after they made it reads as the site fighting them.
     What changed is the other end. Somebody who tapped a face, read it, and then
     wandered off leaves the section frozen on one person forever, and the other
     two never get seen — which is the whole point of the row.

     So an interaction sets a HOLD, and every further interaction restarts it.
     The hold expires after resume_seconds of nothing happening, and the cycle
     picks up from whoever is currently showing rather than jumping back to the
     first person.

     ⚠️ HOVER AND FOCUS ARE NOT ON THAT TIMER — THEY HOLD FOR AS LONG AS THEY
     LAST, and that is what keeps this accessible. WCAG 2.2.2 wants a real way to
     stop content that moves by itself for more than five seconds, and a control
     that only stops it for fifteen seconds is not one. Resting the pointer in
     the row, or tabbing into it, holds the cycle indefinitely; the idle timer
     may well expire underneath, but playAuto refuses while either flag is set
     and the hold is handed straight back on pointerleave / focusout. A pointer
     user and a keyboard user therefore each have an indefinite pause.

     ⚠️ AND IT NEVER MOVES FOCUS. select() is called with focus:false here, so a
     keyboard user reading the page is not dragged into the tablist every few
     seconds. Arrow keys still move focus, because there the user asked.

     What holds or pauses it, and for how long:
       · click or key press on a tab  — holds for resume_seconds, restartable
       · pointer resting in the row   — holds until it leaves
       · keyboard focus in the row    — holds until it leaves
       · section scrolled out of view — pauses, and resumes on the way back

     ⚠️ prefers-reduced-motion SKIPS IT ENTIRELY. Auto-advancing content is
     exactly what that setting is asking us not to do, and the tabs still work.
     Setting resume_seconds to 0 restores the permanent stop for everyone else.
     ========================================================================== */
  const auto = new WeakMap();

  const advance = (list) => {
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    select(list, (current + 1) % tabs.length, false);
  };

  const pauseAuto = (list) => {
    const state = auto.get(list);
    if (!state || !state.id) return;
    window.clearInterval(state.id);
    state.id = null;
  };

  /* ⚠️ FOUR SEPARATE REASONS NOT TO BE RUNNING, AND ALL OF THEM ARE CHECKED HERE
     rather than at the call sites. Each of pointerleave, focusout, the idle timer
     and the observer calls playAuto without knowing what the other three are
     doing, so a visitor who leaves the row while the section is off screen, or
     whose hold expires while they are still hovering, must not start it. */
  const playAuto = (list) => {
    const state = auto.get(list);
    if (!state || state.held || state.hover || state.focused || state.id || !state.visible) return;
    state.id = window.setInterval(() => advance(list), state.ms);
  };

  /* An interaction. Holds the cycle and starts the clock again from zero, so
     somebody working their way along the row keeps pushing the resume out rather
     than being interrupted partway.

     resumeMs of 0 means never resume, which is the original permanent stop. */
  const holdAuto = (list) => {
    const state = auto.get(list);
    if (!state) return;
    state.held = true;
    pauseAuto(list);
    if (state.idleId) window.clearTimeout(state.idleId);
    state.idleId = null;
    if (!(state.resumeMs > 0)) return;
    state.idleId = window.setTimeout(() => {
      state.idleId = null;
      state.held = false;
      playAuto(list);
    }, state.resumeMs);
  };

  const armAuto = (list) => {
    const seconds = parseFloat(list.dataset.drbAutoplay || '0');
    if (!(seconds > 0)) return;
    if (reduce.matches) return;
    if (list.querySelectorAll('[role="tab"]').length < 2) return;

    /* Guarded the same way as the cycle itself: a missing or nonsense value
       falls back to never resuming, which is the safe direction. */
    const resume = parseFloat(list.dataset.drbResume || '0');

    auto.set(list, {
      ms: seconds * 1000,
      resumeMs: resume > 0 ? resume * 1000 : 0,
      id: null,
      idleId: null,
      held: false,
      hover: false,
      focused: false,
      visible: false,
    });

    /* ⚠️ hover and focused are tracked SEPARATELY, not as one shared flag. They
       overlap constantly — clicking a tab fires both pointerenter and focusin —
       and with one flag the focusout on the way to the next tab would clear a
       pointer that never left. */
    const flag = (key, value) => (event) => {
      if (key === 'hover' && event && event.pointerType === 'touch') return;
      const state = auto.get(list);
      if (!state) return;
      state[key] = value;
      if (value) pauseAuto(list);
      else playAuto(list);
    };

    /* ⛔ A FINGER DOES NOT HOVER, AND TREATING IT AS IF IT DOES BREAKS THE PAGE.
       Mike, 2026-09-12: "as soon as i click and scroll up or down, it stops the
       transition from every happening again. The timer bar also stops moving."

       On a touch screen pointerenter fires the moment a finger lands. If that
       touch then becomes a scroll, the browser takes the gesture over and fires
       pointercancel — and pointerleave never arrives. So hover was left stuck at
       true, play() refused forever, and the paused class froze the bar. One
       scroll past the section killed it for the rest of the visit.

       Two guards, because either alone is thin: touch pointers never set hover
       at all, and pointercancel clears it if one ever slips through. */
    list.addEventListener('pointerenter', flag('hover', true));
    list.addEventListener('pointerleave', flag('hover', false));
    list.addEventListener('focusin', flag('focused', true));
    list.addEventListener('focusout', flag('focused', false));
    list.addEventListener('pointercancel', flag('hover', false));

    /* Cycling a section nobody is looking at burns battery and means the first
       thing a visitor sees is a person chosen at random by a timer.

       ⚠️ threshold 0, NOT a fraction. A fraction is a share of the ELEMENT, so
       any section taller than the viewport can never reach it — a 3000px section
       on a 600px screen tops out at 0.2 and would never start cycling at all.
       isIntersecting at threshold 0 means "any of it is on screen", which is the
       question actually being asked here. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const state = auto.get(list);
          if (!state) return;
          state.visible = entry.isIntersecting;
          if (entry.isIntersecting) playAuto(list);
          else pauseAuto(list);
        });
      }, { threshold: 0 }).observe(list.closest('.drb-docs') || list);
    } else {
      const state = auto.get(list);
      state.visible = true;
      playAuto(list);
    }
  };

  const init = () => {
    document.querySelectorAll('[data-drb-tabs]').forEach((list) => {
      if (list.dataset.drbReady === 'true') return;
      list.dataset.drbReady = 'true';

      /* ⚠️ THE STACKING CLASS IS ADDED BY SCRIPT, NOT WRITTEN INTO THE MARKUP,
         and that is the whole reason it is a class at all. It collapses the
         three panels into one grid cell so the section stops changing height as
         the cycle advances — but with no JS, nothing carries the hidden
         attribute, and three visible panels in one cell would render as three
         profiles printed on top of each other. Unreadable, where the no-JS
         fallback is supposed to be merely long. Adding it here means it can only
         ever apply once something is actually hiding panels. */
      const section = list.closest('.drb-docs');
      const panels = section && section.querySelector('.drb-docs__panels');
      if (panels) panels.classList.add('is-stacked');

      select(list, 0, false);
      armAuto(list);
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const list = tab.closest('[data-drb-tabs]');
    if (!list) return;
    holdAuto(list);
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    select(list, tabs.indexOf(tab), false);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[role="tab"]');
    if (!tab) return;
    const list = tab.closest('[data-drb-tabs]');
    if (!list) return;

    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const current = tabs.indexOf(tab);
    let next = null;

    /* A key press is a decision, the same as a click. */
    holdAuto(list);

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;

    if (next === null) return;
    event.preventDefault();
    select(list, next, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-hero"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   THE ROTATING HERO
   ============================================================================
   Mike, 2026-09-12: "So the women's is supposed to be a second hero banner that
   occupies the same spot as the gut health... probably needs to be setup as a
   rotating hero section."

   ⚠️ I ARGUED AGAINST THIS AND HE ASKED TWICE, SO IT IS BUILT. Recording the
   reasoning anyway, because whoever reads this next deserves the context rather
   than a mystery: a rotating hero is the classic cause of a bad CLS and LCP, and
   the live theme this replaces scores CLS 1.02 against a target under 0.1.

   What that means is that the COST HAS TO BE ENGINEERED OUT rather than
   accepted, and three things do it. Do not undo any of them casually:

     1. The slides share one grid cell, so the section never changes height.
     2. Only the first image is eager + high priority. The rest are lazy + low,
        so the browser is not handed two LCP candidates to race.
     3. The off slides are visibility:hidden rather than display:none, so their
        boxes still size the cell and their images can still fetch in advance.

   Nothing here animates layout — only opacity — so a rotation costs no reflow.
   ============================================================================ */
/* ⚠️ WHY THE ROTATION RANGE IS 0-10 AT A TENTH OF A SECOND, AND WHY THE SCHEMA
   DOES NOT SAY SO ITSELF.

   Mike asked for 6.2s by name. The range was 0-15 at 0.5, so 6.2 was not a value
   it could hold — and Shopify validates a template's stored setting against the
   step, so templates/index.json would not take it either. A tenth needs the
   ceiling at 10, because a range may not exceed 101 steps and 0-15 at 0.1 is 150.

   ⛔ THAT EXPLANATION LIVES HERE RATHER THAN IN THE SETTING'S "info" BECAUSE AN
   OVER-LONG info IS SILENTLY REJECTED BY themeFilesUpsert. Adding it there took
   the string to 607 characters and the push started returning success while
   changing nothing on the theme — six pushes to find. 480 is the working
   ceiling; a Liquid comment has no limit. See CLAUDE.md. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const state = new WeakMap();

  const slidesOf = (root) => Array.from(root.querySelectorAll('.drb-hero__slide'));
  const dotsOf = (root) => Array.from(root.querySelectorAll('[data-drb-hero-go]'));

  const show = (root, index) => {
    const slides = slidesOf(root);
    if (!slides.length) return;
    const n = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.setAttribute('data-drb-active', i === n ? 'true' : 'false'));
    dotsOf(root).forEach((d, i) => d.setAttribute('aria-current', i === n ? 'true' : 'false'));

    /* The timer bar sits outside the slides, so it cannot inherit the accent of
       whichever one is showing. Copy it up to the section on every change. */
    const active = slides[n];
    if (active) {
      const accent = getComputedStyle(active).getPropertyValue('--drb-hero-accent').trim();
      if (accent) root.style.setProperty('--drb-hero-dot', accent);
    }

    const st = state.get(root);
    if (st) st.index = n;
  };

  const stop = (root) => {
    const st = state.get(root);
    if (!st || !st.id) return;
    window.clearInterval(st.id);
    st.id = null;
    /* The bar has to freeze with the rotation or it promises a swap that is not
       coming. CSS does the freezing; this only says when. */
    root.classList.add('drb-hero--paused');
  };

  const play = (root) => {
    const st = state.get(root);
    if (!st || st.steered || st.hover || st.focused || st.id || !st.visible) return;
    st.id = window.setInterval(() => show(root, st.index + 1), st.ms);
    root.classList.remove('drb-hero--paused');
  };

  /* ⚠️ THIS USED TO BE PERMANENT AND THE ARGUMENT FOR IT WAS SOUND ONLY WHILE
     STEERING WAS DELIBERATE. It read: swiping a hero is somebody saying which of
     two products they want, and taking it back on a timer is the thing people
     hate about carousels. True — but tap-to-advance was firing on any touch
     under 10px of movement, so the commonest way to reach this function on a
     phone was by accident, and one accidental brush stopped the hero for the
     rest of the visit with the timer bar sitting solid.

     The tap zone is off on touch now, so steering really is deliberate again.
     The hold still expires, because twelve seconds is long enough to read a
     hero somebody chose and short enough that an accident cannot leave the page
     dead. Every other control on this site now works that way.

     ⛔ AND IT NEVER EXPIRES WHERE THERE IS NOTHING TO RETURN TO: reduced motion
     does not rotate at all, and st.ms is 0 when rotation is switched off. */
  const HERO_RESUME_MS = 12000;

  const steer = (root) => {
    const st = state.get(root);
    if (!st) return;
    st.steered = true;
    stop(root);
    /* ⚠️ AND THE PAUSED CLASS COMES OFF. Stopped is not paused: paused freezes a
       part-filled bar mid-way, which would read as "still counting". Stopped
       drops the animation entirely and shows a solid bar for the slide you are
       on. Leaving both classes would keep the frozen partial fill. */
    root.classList.remove('drb-hero--paused');
    root.classList.add('drb-hero--stopped');

    if (st.resumeId) window.clearTimeout(st.resumeId);
    st.resumeId = null;
    if (!(st.ms > 0) || reduce.matches) return;

    st.resumeId = window.setTimeout(() => {
      st.resumeId = null;
      st.steered = false;
      root.classList.remove('drb-hero--stopped');
      play(root);
    }, HERO_RESUME_MS);
  };

  /* ---------- swipe, and tap the sides of the photograph ----------
     Mike, 2026-09-12: "some places you just click on the left or right side of
     the hero image and it scrolls for you, very few allow you to drag your
     finger across but the ones that do are still fine. Having to click on that
     thin bar every time is annoying."

     Both, because they are the same three numbers and they fail in opposite
     directions: a tap is discoverable and a swipe is not, but a swipe is what a
     thumb reaches for first on a phone. The timer bar stays exactly as it is —
     it is the state display and the keyboard control, it was just never meant
     to be the only way in.

     ⛔ NO ARROWS HERE, and that is deliberate rather than an omission. Mike
     asked for the gesture "(no arrows)". The reviews band needs them because a
     mouse cannot drag a scroll container natively; this one does not, because
     the dots are already a visible, clickable control sitting under the copy.

     ⚠️ THERE IS A touch-action RULE IN THE CSS AND IT IS REQUIRED. This comment
     used to say the opposite — that leaving touch-action alone was deliberate,
     because pan-y would cost pinch-zoom over the largest image on the site. The
     first half of that was wrong and Mike found it in minutes: "on mobile it
     doesn't work in the top text area, only in the image section."

     The split is selectable text versus an image. A touch-drag that starts on
     text is handed to the browser's text-interaction machinery before this code
     sees it move, and pointercancel arrives instead of pointerup — the guard
     below then correctly drops a gesture that was never delivered. The
     photograph is not selectable, so the same swipe survives there. One hero,
     two behaviours, depending on what was under the thumb.

     The CSS fixes both halves: pan-y pinch-zoom claims the horizontal axis
     explicitly (and the second keyword is what keeps the zoom the old comment
     was protecting), and user-select: none on the copy stops the text grabbing
     the gesture. Both are scoped to hover: none, so a mouse can still select and
     copy the headline. */
  /* ⚠️ FOUR NUMBERS, AND THE GAP BETWEEN THE FIRST TWO IS WHAT USED TO BE DEAD.
     Below COMMIT the slide does not change, but the fade still tracks the finger
     and springs back, so a short swipe reads as "not far enough" instead of as
     nothing happening at all. TRAVEL is deliberately larger than COMMIT: it
     means the fade is only ever part-way when the threshold is crossed, so the
     release always finishes the motion rather than the finger completing it. */
  const DRAG_INTENT = 8;
  const DRAG_COMMIT = 40;
  const DRAG_TRAVEL = 110;
  const PEEK_CAP = 0.85;

  const armGestures = (root) => {
    let g = null;

    /* ⚠️ THE CLASS COMES OFF NOW AND THE INLINE STYLES GO ON THE NEXT FRAME, AND
       THAT ORDER IS THE WHOLE TRICK. --dragging kills the transition so the fade
       can track the finger. If the inline opacity were cleared in the same task
       as the class, the browser would compute one style change with the
       transition already back on and the result is engine-dependent. Removing
       the class first, then clearing a frame later, means the transition rule is
       already in force when the opacity changes, so it animates every time. */
    const releasePeek = () => {
      root.classList.remove('drb-hero--dragging');
      window.requestAnimationFrame(() => {
        slidesOf(root).forEach((slide) => {
          slide.style.opacity = '';
          slide.style.visibility = '';
        });
      });
    };

    const endDrag = (commit, dir) => {
      const st = state.get(root);
      g = null;

      if (commit && st) {
        steer(root);
        show(root, st.index + dir);
        releasePeek();
        return;
      }

      releasePeek();
      /* ⛔ ONLY IF THERE IS A CYCLE TO RETURN TO. st.ms is 0 when rotation is
         switched off, and play() would hand setInterval a delay of 0. */
      if (st && st.ms > 0) play(root);
    };

    root.addEventListener('pointerdown', (event) => {
      if (event.button && event.button !== 0) return;
      /* The CTAs and the dots are real controls and win the gesture. */
      if (event.target.closest('a, button')) return;
      g = {
        x: event.clientX,
        y: event.clientY,
        id: event.pointerId,
        axis: null,
        dir: 0,
        touch: event.pointerType === 'touch',
      };
    });

    /* ---------- the fade follows the finger ----------
       ⛔ WITHOUT THIS THE GESTURE HAD NO FEEDBACK AT ALL. Mike, 2026-09-12: "The
       left right hero scroll functionality is wonky at best on mobile."

       Nothing moved until the finger lifted, and then a 0.6s crossfade started —
       so mid-swipe there was no way to tell whether the hero had registered the
       gesture, whether it was about to change, or which way. The reviews band he
       called "great" tracks the finger; this did not, and that difference is
       most of what "wonky" meant.

       The slides share one grid cell and cross-fade, so the honest thing for the
       drag to drive is that same fade rather than a translation. It also happens
       to be the safe one: opacity changes nothing about layout, which matters on
       the LCP section of a page whose whole CLS budget is 0.1. */
    root.addEventListener('pointermove', (event) => {
      if (!g || event.pointerId !== g.id) return;

      const dx = event.clientX - g.x;
      const dy = event.clientY - g.y;

      if (!g.axis) {
        if (Math.abs(dx) < DRAG_INTENT && Math.abs(dy) < DRAG_INTENT) return;
        g.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        /* A vertical gesture is the page scrolling. Drop the candidate and stay
           out of the way — touch-action already gave that axis to the browser. */
        if (g.axis === 'y') {
          g = null;
          return;
        }
        stop(root);
        root.classList.add('drb-hero--dragging');
      }

      const slides = slidesOf(root);
      const st = state.get(root);
      if (slides.length < 2 || !st) return;

      const dir = dx < 0 ? 1 : -1;
      /* Dragged back past the start: the other slide is the candidate now, so
         the old one has to be released or two would sit part-faded at once. */
      if (dir !== g.dir) {
        slides.forEach((slide) => {
          slide.style.opacity = '';
          slide.style.visibility = '';
        });
        g.dir = dir;
      }

      const n = (((st.index + dir) % slides.length) + slides.length) % slides.length;
      const p = Math.min(Math.abs(dx) / DRAG_TRAVEL, 1) * PEEK_CAP;
      const current = slides[st.index];
      const next = slides[n];

      if (current) current.style.opacity = String(1 - p);
      if (next && next !== current) {
        /* The resting rule hides it with visibility, so opacity alone would not
           bring it back. */
        next.style.visibility = 'visible';
        next.style.opacity = String(p);
      }
    });

    root.addEventListener('pointercancel', () => {
      if (g) endDrag(false, 0);
    });

    root.addEventListener('pointerup', (event) => {
      if (!g || event.pointerId !== g.id) return;

      const dx = event.clientX - g.x;
      const dy = event.clientY - g.y;
      const dragged = g.axis === 'x';
      const touch = g.touch;

      if (dragged) {
        endDrag(Math.abs(dx) >= DRAG_COMMIT, dx < 0 ? 1 : -1);
        return;
      }

      g = null;
      const st = state.get(root);
      if (!st) return;

      /* ---------- a tap, on pointer devices only ----------
         ⛔ TAP-TO-ADVANCE IS OFF ON TOUCH AND THAT IS A FIX, NOT A REGRESSION.
         Mike asked for it, 2026-09-12: "some places you just click on the left or
         right side of the hero image and it scrolls for you." On a mouse it is
         exactly that. On a phone it was firing on any touch under 10px of
         movement — which is most of them. Resting a thumb on the photograph
         while reading, or starting a scroll that the finger did not actually
         move, jumped the hero to the other product; and because steering used to
         be permanent, that one accident also stopped the rotation for good.

         A phone already has the better gesture. A swipe says "next" with no
         ambiguity, so the tap zone buys nothing there and costs this.

         ⚠️ The side is measured against the hero rather than the image, because
         on desktop the photograph is position: absolute; inset: 0 behind
         everything and .drb-hero__body covers the full width — testing the image
         found nothing, which is the bug this replaced. Anywhere in the hero
         EXCEPT the copy, which holds a heading, a paragraph and two buttons. */
      if (touch) return;
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        if (event.target.closest('.drb-hero__copy')) return;
        const rect = root.getBoundingClientRect();
        steer(root);
        show(root, st.index + (event.clientX - rect.left > rect.width / 2 ? 1 : -1));
      }
    });
  };

  const arm = (root) => {
    if (root.dataset.drbReady === 'true') return;
    root.dataset.drbReady = 'true';

    const seconds = parseFloat(root.dataset.drbHeroSeconds || '0');
    state.set(root, {
      index: 0,
      ms: seconds > 0 ? seconds * 1000 : 0,
      id: null,
      steered: false,
      resumeId: null,
      hover: false,
      focused: false,
      visible: false,
    });

    show(root, 0);

    /* ⚠️ BEFORE THE EARLY RETURN BELOW, NOT AFTER IT. The gesture is navigation,
       not motion: it has to work for someone who has asked to reduce motion and
       for a hero whose rotation is switched off, exactly as the dots do. Wiring
       it further down would silently give both of those visitors a hero they can
       only change by hitting a 30px bar. */
    if (slidesOf(root).length > 1) armGestures(root);

    /* ⛔ prefers-reduced-motion DOES NOT ROTATE AT ALL. A hero that changes under
       you is exactly what that setting is asking us not to do. The dots still
       work, so nothing is unreachable — it just never moves on its own. */
    if (!(seconds > 0) || reduce.matches || slidesOf(root).length < 2) return;

    const flag = (key, value) => (event) => {
      if (key === 'hover' && event && event.pointerType === 'touch') return;
      const st = state.get(root);
      if (!st) return;
      st[key] = value;
      if (value) stop(root);
      else play(root);
    };

    /* ⛔ A FINGER DOES NOT HOVER, AND TREATING IT AS IF IT DOES BREAKS THE PAGE.
       Mike, 2026-09-12: "as soon as i click and scroll up or down, it stops the
       transition from every happening again. The timer bar also stops moving."

       On a touch screen pointerenter fires the moment a finger lands. If that
       touch then becomes a scroll, the browser takes the gesture over and fires
       pointercancel — and pointerleave never arrives. So hover was left stuck at
       true, play() refused forever, and the paused class froze the bar. One
       scroll past the section killed it for the rest of the visit.

       Two guards, because either alone is thin: touch pointers never set hover
       at all, and pointercancel clears it if one ever slips through. */
    root.addEventListener('pointerenter', flag('hover', true));
    root.addEventListener('pointerleave', flag('hover', false));
    root.addEventListener('focusin', flag('focused', true));
    root.addEventListener('focusout', flag('focused', false));
    root.addEventListener('pointercancel', flag('hover', false));

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const st = state.get(root);
          if (!st) return;
          st.visible = entry.isIntersecting;
          if (entry.isIntersecting) play(root);
          else stop(root);
        });
      }, { threshold: 0 }).observe(root);
    } else {
      const st = state.get(root);
      st.visible = true;
      play(root);
    }
  };

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-drb-hero-go]');
    if (!dot) return;
    const root = dot.closest('[data-drb-hero]');
    if (!root) return;
    steer(root);
    show(root, parseInt(dot.dataset.drbHeroGo, 10) || 0);
  });

  const init = () => document.querySelectorAll('[data-drb-hero]').forEach(arm);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-practitioners"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   THE TESTIMONIAL SLIDER AND THE PRICING GATE
   ============================================================================
   Delegated from the document so two of these on one page cannot fight, and so
   it survives the theme editor re-rendering the section.
   ============================================================================ */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ==========================================================================
     SLIDER
     ==========================================================================
     Mike: "I'd have that testimonial section have a left-right slider that
     cycles every 2 seconds."

     ⚠️ TWO SECONDS IS FAST FOR READING, and the pause rules are what make it
     usable rather than hostile. Pointer or keyboard focus anywhere in the slider
     holds it for as long as it lasts; using an arrow or dragging holds it for
     RESUME_MS, long enough to read the quote you stopped on, and any further
     steering restarts that clock. Off screen it does not run at all.

     ⚠️ prefers-reduced-motion SKIPS THE CYCLE ENTIRELY. The arrows still work,
     so nothing is lost — it just stops moving on its own.
     ========================================================================== */
  const state = new WeakMap();

  const slidesOf = (root) => Array.from(root.querySelectorAll('.drb-prac__slide'));

  const show = (root, index) => {
    const slides = slidesOf(root);
    if (!slides.length) return;
    const n = ((index % slides.length) + slides.length) % slides.length;
    slides.forEach((s, i) => {
      s.hidden = i !== n;
    });
    root.querySelectorAll('.drb-prac__pip').forEach((pip, i) => {
      pip.classList.toggle('is-on', i === n);
    });
    const s = state.get(root);
    if (s) s.index = n;
  };

  const stop = (root) => {
    const s = state.get(root);
    if (!s || !s.id) return;
    window.clearInterval(s.id);
    s.id = null;
  };

  const play = (root) => {
    const s = state.get(root);
    if (!s || s.steered || s.hover || s.focused || s.id || !s.visible) return;
    s.id = window.setInterval(() => show(root, s.index + 1), s.ms);
  };

  /* ⚠️ THIS USED TO BE PERMANENT, on the reasoning that reaching for an arrow is
     a clear statement that you want to read rather than watch. Mike, 2026-09-12:
     "after you touch it to scroll anyway at all it never starts scrolling on its
     own again."

     The reasoning held for the reader; it did not hold for the much commoner
     visitor who brushes the quote on the way past and leaves a dead panel behind
     for the rest of the session. It matters more here than it used to, because
     the arrows are gone on touch now — a phone user who nudged it would have had
     a frozen quote and nothing at all to move it with.

     So the hold expires, on the same pattern as the doctors row and the reviews
     band. Any fresh steer restarts the clock, so somebody actually working
     through the quotes is never interrupted. */
  /* ⚠️ WAS 15s AND THAT READ AS BROKEN ON A LAPTOP. Mike, 2026-09-12: "on
     desktop seems the new practitioner quote section takes too long to start up
     again when you click off of it."

     Fifteen came from the doctors row, where a panel holds a whole profile. Here
     a quote takes four seconds, so a hold of fifteen is nearly four cycles of
     nothing — long enough that a visitor concludes it stopped rather than that
     it is waiting. Six gives whoever pressed an arrow time to finish the quote
     they chose and still comes back while they are looking at it. */
  const RESUME_MS = 6000;

  const steer = (root) => {
    const s = state.get(root);
    if (!s) return;
    s.steered = true;
    stop(root);
    if (s.resumeId) window.clearTimeout(s.resumeId);
    s.resumeId = window.setTimeout(() => {
      s.resumeId = null;
      s.steered = false;
      play(root);
    }, RESUME_MS);
  };

  const armSlider = (root) => {
    if (root.dataset.drbReady === 'true') return;
    root.dataset.drbReady = 'true';

    const seconds = parseFloat(root.dataset.drbSeconds || '0');
    state.set(root, {
      index: 0,
      ms: seconds > 0 ? seconds * 1000 : 0,
      id: null,
      steered: false,
      resumeId: null,
      hover: false,
      focused: false,
      visible: false,
    });

    show(root, 0);

    if (!(seconds > 0) || reduce.matches || slidesOf(root).length < 2) return;

    const flag = (key, value) => (event) => {
      if (key === 'hover' && event && event.pointerType === 'touch') return;
      const s = state.get(root);
      if (!s) return;
      s[key] = value;
      if (value) stop(root);
      else play(root);
    };

    /* ⛔ A FINGER DOES NOT HOVER, AND TREATING IT AS IF IT DOES BREAKS THE PAGE.
       Mike, 2026-09-12: "as soon as i click and scroll up or down, it stops the
       transition from every happening again. The timer bar also stops moving."

       On a touch screen pointerenter fires the moment a finger lands. If that
       touch then becomes a scroll, the browser takes the gesture over and fires
       pointercancel — and pointerleave never arrives. So hover was left stuck at
       true, play() refused forever, and the paused class froze the bar. One
       scroll past the section killed it for the rest of the visit.

       Two guards, because either alone is thin: touch pointers never set hover
       at all, and pointercancel clears it if one ever slips through. */
    root.addEventListener('pointerenter', flag('hover', true));
    root.addEventListener('pointerleave', flag('hover', false));
    root.addEventListener('focusin', flag('focused', true));
    root.addEventListener('focusout', flag('focused', false));
    root.addEventListener('pointercancel', flag('hover', false));

    /* ---------- drag ----------
       Mike asked for "something you can just drag". Pointer events cover mouse,
       pen and touch in one path.

       ⚠️ 40px THRESHOLD, AND IT IS NOT ARBITRARY. Below that a drag is
       indistinguishable from a click that wobbled, and every tap on the quote
       would jump the slider. Above it, the gesture is unambiguous.

       ⚠️ touch-action: pan-y IS SET IN THE CSS AND IS LOAD-BEARING. Without it
       the browser hands us the vertical gesture too and the page stops
       scrolling under a thumb that starts on the testimonial. */
    let dragFrom = null;

    root.addEventListener('pointerdown', (event) => {
      if (event.button && event.button !== 0) return;
      if (event.target.closest('button')) return;
      dragFrom = event.clientX;
    });

    root.addEventListener('pointercancel', () => {
      dragFrom = null;
    });

    root.addEventListener('pointerup', (event) => {
      if (dragFrom === null) return;
      const dx = event.clientX - dragFrom;
      dragFrom = null;
      if (Math.abs(dx) < 40) return;
      const st = state.get(root);
      if (!st) return;
      steer(root);
      show(root, st.index + (dx < 0 ? 1 : -1));
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const s = state.get(root);
          if (!s) return;
          s.visible = entry.isIntersecting;
          if (entry.isIntersecting) play(root);
          else stop(root);
        });
      }, { threshold: 0 }).observe(root);
    } else {
      const s = state.get(root);
      s.visible = true;
      play(root);
    }
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-drb-prev], [data-drb-next]');
    if (!control) return;
    const root = control.closest('[data-drb-slider]');
    if (!root) return;
    const s = state.get(root);
    if (!s) return;
    steer(root);
    show(root, s.index + (control.hasAttribute('data-drb-next') ? 1 : -1));
  });

  /* ==========================================================================
     THE GATE
     ==========================================================================
     ⛔ THIS DIALOG IS A LEAD FORM, NOT AN ACCESS CONTROL, and the distinction is
     load-bearing. Nothing it guards is present in the page — the pricing cells
     contain mask characters, not blurred numbers — so there is nothing for
     closing it to protect and nothing for bypassing it to reveal. If anyone ever
     "improves" this by putting the real figures in the markup and having the
     script swap them in on submit, the gate becomes decorative and the whole
     wholesale sheet ships to every crawler. See the rule at the top of the file.
     ========================================================================== */
  const openDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drb-gate-open]');
    if (opener) {
      openDialog(document.getElementById(opener.dataset.drbGateOpen));
      return;
    }

    const closer = event.target.closest('[data-drb-gate-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog && typeof dialog.close === 'function') dialog.close();
      else if (dialog) dialog.removeAttribute('open');
      return;
    }

    /* Clicking the backdrop. A <dialog> reports the whole viewport as its own
       hit area, so the test is "was the click outside the form box", not "was
       the target the dialog". */
    const dialog = event.target.closest('dialog.drb-prac__dialog');
    if (!dialog || event.target !== dialog) return;
    const box = dialog.querySelector('.drb-prac__gate');
    if (!box) return;
    const r = box.getBoundingClientRect();
    const inside =
      event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
    if (!inside) dialog.close();
  });

  const init = () => {
    document.querySelectorAll('[data-drb-slider]').forEach(armSlider);

    /* Reopen after a post — see the note on the dialog in the markup. */
    document.querySelectorAll('.drb-prac__dialog [data-drb-gate-state]').forEach((marker) => {
      openDialog(marker.closest('dialog'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-reviews"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   THE REVIEW RAIL
   ============================================================================
   ⚠️ NATIVE SCROLLING THROUGHOUT. The rail is a real overflow-x container with
   scroll snapping, and the timer, the arrows, the finger and the trackpad all
   move the same scrollLeft. There is no second mechanism and therefore no
   hand-off — which is the part the homepage marquee had to solve by reading an
   animated transform out of the computed style and writing it into scrollLeft.

   ⭐ THE LOOP IS A CONVEYOR, NOT A REWIND. When a card has been scrolled fully
   past, it is moved to the END of the list and the same width is subtracted
   from scrollLeft in the same frame. Nothing moves on screen, the rail is
   never near its end, and the row runs forever without the duplicated track
   the homepage needs or a visible snap back to the first card.

   ⭐ AND THAT IS ALSO WHAT PROMOTES THE BIG QUOTE. The card just moved to the
   end IS the one that just left, so "the most recently departed review" is
   simply rail.lastElementChild — no index to keep, nothing to drift, and it
   stays true whether the rail was moved by the timer, an arrow or a thumb.
   ============================================================================ */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* How long the rail waits, untouched, before it starts moving on its own
     again. Long enough to read a card twice; short enough that a row someone
     brushed past does not stay frozen for the rest of the visit. The homepage
     band uses the same idea. */
  const RESUME_MS = 9000;

  document.querySelectorAll('[data-drb-revrail]').forEach((scroller) => {
    const rail = scroller.querySelector('[data-drb-revrail-rail]');
    if (!rail) return;

    const section = scroller.closest('.drb-revs');
    const stack = section && section.querySelector('[data-drb-revhero]');
    const slides = stack ? Array.prototype.slice.call(stack.children) : [];

    const gap = () => parseFloat(getComputedStyle(rail).columnGap) || 0;

    const width = (card) => (card ? card.getBoundingClientRect().width + gap() : 0);

    const step = () => width(rail.firstElementChild) || rail.clientWidth * 0.8;

    /* ⚠️ A ROW THAT ALREADY FITS MUST NOT CONVEY. With four cards in a four-up
       rail there is nothing off screen, so shuffling the order would move
       cards around for no reason and promote quotes nobody saw leave. */
    const scrollable = () => rail.scrollWidth > rail.clientWidth + 4;

    /* Slide 0 is the section's empty-state; card n maps to slide n + 1.

       ⚠️ THE CARD IS MARKED AS WELL AS THE SLIDE, and the mark is the whole
       point of the change — without it the enlarged quote has no visible
       relationship to the row it came out of. */
    const promote = (card) => {
      if (!card || slides.length < 2) return;
      const n = parseInt(card.getAttribute('data-index'), 10);
      if (!isFinite(n)) return;
      Array.prototype.forEach.call(rail.children, (c) =>
        c.classList.toggle('is-current', c === card)
      );
      slides.forEach((slide, i) => {
        const on = i === n + 1;
        slide.classList.toggle('is-on', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
    };

    /* Called once the scrolling has settled, however it was caused. Every card
       that is now fully behind the left edge is conveyed to the end, so a slow
       thumb drag across three cards promotes all three in turn and lands on
       the right one. */
    const normalise = () => {
      let guard = 0;
      while (guard++ < 24) {
        const first = rail.firstElementChild;
        if (!first) return;
        const w = width(first);
        if (w <= 0 || rail.scrollLeft < w - 1) return;
        rail.appendChild(first);
        rail.scrollTo({ left: rail.scrollLeft - w, behavior: 'auto' });
        /* The card just conveyed to the end has gone; the one now at the front
           is the new leftmost, and that is the selected one. */
        promote(rail.firstElementChild);
      }
    };

    const forward = () => {
      if (!scrollable()) return;
      rail.scrollTo({
        left: rail.scrollLeft + step(),
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
      if (reduce.matches) normalise();
    };

    /* ⚠️ BACKWARDS IS THE CONVEYOR RUN IN REVERSE, AND THE ORDER MATTERS. The
       last card is moved to the front and the same width added to scrollLeft
       in the same frame, so nothing appears to happen; only then does the
       smooth scroll back reveal it. Done the other way round the rail would
       visibly jump before it moved. */
    const back = () => {
      if (!scrollable()) return;
      const last = rail.lastElementChild;
      if (!last) return;
      const w = width(last);
      rail.insertBefore(last, rail.firstElementChild);
      rail.scrollTo({ left: rail.scrollLeft + w, behavior: 'auto' });
      rail.scrollTo({ left: Math.max(0, rail.scrollLeft - w), behavior: reduce.matches ? 'auto' : 'smooth' });
      promote(rail.firstElementChild);
    };

    /* ⚠️ THE 2px SLACK IS LOAD-BEARING. scrollLeft is fractional on a zoomed or
       high-DPI display, so scrollWidth - clientWidth is almost never reached
       exactly and a strict compare leaves an arrow lit at the end forever.
       With the conveyor running, is-end only ever shows on a row too short to
       scroll — which is exactly when both arrows should be gone. */
    const mark = () => {
      scroller.classList.toggle('is-start', !scrollable() && rail.scrollLeft <= 2);
      scroller.classList.toggle(
        'is-end',
        !scrollable() || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2
      );
    };

    /* ⭐ A CLICK PUTS THAT REVIEW IN THE BIG QUOTE AND HOLDS THE ROW THERE.
       Mike, 2026-09-22: "when i hover over in the PDP testimonial section and
       then click on a testimonial do you think it should be the one that
       pops-up in the top area? This way it's easier to read?" — and then
       "Then same treatment when you click on one."

       ⭐ IT ALSO FIXES SOMETHING THAT WAS ALREADY WRONG. The click used to only
       latch the row, which is a control with no visible result: the arrows
       appearing was the entire feedback, and a click that looks like it did
       nothing reads as broken rather than as subtle. Now a click does the same
       thing the rail does when it advances, which is why there is one promote()
       and not two code paths.

       ⚠️ ABOVE THE REDUCED-MOTION RETURN ON PURPOSE. Choosing a review to read
       is not motion, so it has to keep working for someone who has asked the
       operating system to stop things moving — and on a section whose autoplay
       is switched off in the editor.

       ⚠️ THE TOGGLE IS ON THE SELECTED CARD, NOT ON ANY CARD. Clicking a
       different one selects it and stays held; clicking the one already in the
       big quote releases the hold. A plain toggle would mean the second click
       of "read this one, now that one" quietly started the row moving again
       underneath the reader.

       ⚠️ AND A CARD IS STILL NOT A BUTTON. It takes a pointer cursor now,
       because it does something — but no role and no tabindex, because the
       full review is already legible in the card. This enlarges text that is
       on the page either way; it is an enhancement, not the only way in. */
    let latched = false;
    rail.addEventListener('click', (event) => {
      const card = event.target.closest('.drb-revs__card');
      if (!card) return;
      const wasCurrent = card.classList.contains('is-current');
      promote(card);
      latched = !(wasCurrent && latched);
      scroller.classList.toggle('is-held', latched);
    });

    let settle = null;
    rail.addEventListener(
      'scroll',
      () => {
        clearTimeout(settle);
        settle = setTimeout(() => {
          normalise();
          mark();
        }, 140);
      },
      { passive: true }
    );

    /* ---- the clock ---- */

    let held = 0;
    const touch = () => {
      held = Date.now();
    };
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) =>
      scroller.addEventListener(type, touch, { passive: true })
    );

    const prev = scroller.querySelector('[data-drb-revrail-prev]');
    const next = scroller.querySelector('[data-drb-revrail-next]');
    if (prev) prev.addEventListener('click', () => { touch(); back(); });
    if (next) next.addEventListener('click', () => { touch(); forward(); });

    mark();

    /* ⛔ NO TIMER AT ALL UNDER REDUCED MOTION. The arrows and the drag still
       work; the row simply never starts by itself. A person who has asked the
       operating system to stop things moving has asked for this specifically.

       ⚠️ AND NONE WHILE THE SECTION IS OFF SCREEN. A rail that keeps stepping
       at the bottom of a long page is work nobody sees, and it would also
       leave the big quote showing a review that departed while the reader was
       three screens away. */
    if (reduce.matches || scroller.hasAttribute('data-still')) return;

    const seconds = parseFloat(scroller.getAttribute('data-seconds')) || 3;
    const startAfter = parseFloat(scroller.getAttribute('data-start')) || 0;
    let onScreen = false;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => entries.forEach((e) => { onScreen = e.isIntersecting; }),
        { threshold: 0.2 }
      ).observe(scroller);
    } else {
      onScreen = true;
    }

    const tick = () => {
      if (latched) return;
      if (!onScreen || document.hidden) return;
      if (Date.now() - held < RESUME_MS) return;
      /* Hovering or tabbing into the row is reading it. */
      if (scroller.matches(':hover')) return;
      if (scroller.contains(document.activeElement)) return;
      forward();
    };

    /* ⚠️ A DELAY BEFORE THE FIRST STEP, THEN A SHORTER GAP BETWEEN THEM, AND
       THE TWO ARE SEPARATE NUMBERS ON PURPOSE. Mike, 2026-09-22: "maybe starts
       after 5s and then scrolls every 3". The first step is the one that has
       to wait: a row that moves the moment it appears has moved before the
       reader has finished arriving at it, and the big quote beside it changes
       with it. After that the reader knows the row moves, and three seconds is
       a glance at a card rather than a wait.

       ⛔ setTimeout THEN setInterval, NOT one interval at the longer time. An
       interval of 5s would put every subsequent step 5s apart too, which is
       the opposite of what he asked for. */
    setTimeout(() => {
      tick();
      setInterval(tick, seconds * 1000);
    }, Math.max(0, startAfter * 1000));
  });
})();

/* ============================================================================
   THE PRODUCT FILTER (grid layout)
   ============================================================================
   ⚠️ THE SERVER NEVER HIDES A CARD. Every review is in the markup and visible
   before this runs, so with script off the page is a complete, readable list
   rather than an empty grid with three dead buttons. The filter is an
   enhancement on top of a page that already works.

   ⚠️ hidden, NOT display:none in a class. A hidden card is removed from the
   accessibility tree and from tab order; a class that only sets display can
   be beaten by a later rule and leaves the card findable by screen readers
   while invisible on screen, which is the worst of both.

   ⭐ NOTHING HERE RESUMES. The site rule is that anything which moves stops
   when someone looks at it and resumes when they leave — but grid layout has
   no timer, no transform and no autoplay, so a filter click is simply a
   choice that holds until another one is made. */
(function () {
  if (window.__drbRevGrid) return;
  window.__drbRevGrid = true;

  function wire(grid) {
    var sec = grid.closest('.drb-revs');
    if (!sec) return;
    var btns = sec.querySelectorAll('[data-drb-rvf]');
    var cards = grid.querySelectorAll('.drb-revs__gcard');
    if (!btns.length || !cards.length) return;

    function apply(key) {
      Array.prototype.forEach.call(cards, function (c) {
        c.hidden = !(key === 'all' || c.getAttribute('data-product') === key);
      });
      Array.prototype.forEach.call(btns, function (b) {
        var on = b.getAttribute('data-drb-rvf') === key;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-drb-rvf')); });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drb-rvgrid]'), wire);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-study"] && !Shopify.designMode) return;
  try {
    
/* Delegated from the document rather than bound per section, so it survives the
   theme editor re-rendering a section without needing to re-initialise, and so
   two of these sections on one page cannot fight over listeners. */
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-drb-chart-open]');
  if (opener) {
    const modal = opener.closest('.drb-study').querySelector('[data-drb-chart-modal]');
    if (modal && typeof modal.showModal === 'function') modal.showModal();
    return;
  }

  /* ⚠️ THE LINK IS INTERCEPTED, NOT REPLACED. preventDefault only runs once
     we know the dialog exists and the browser supports showModal, so every
     path that is not "we can definitely open the panel" falls through to the
     anchor's own behaviour and the paper still opens. */
  const paper = event.target.closest('[data-drb-paper]');
  if (paper) {
    const modal = paper.closest('.drb-study').querySelector('[data-drb-paper-modal]');
    if (modal && typeof modal.showModal === 'function') {
      event.preventDefault();
      const frame = modal.querySelector('[data-drb-paper-frame]');
      /* Set once. Re-setting on every open reloads a third-party page each
         time the panel is reopened. */
      if (frame && !frame.src) frame.src = frame.dataset.src;
      modal.showModal();
    }
    return;
  }

  const closer = event.target.closest('[data-drb-chart-close], [data-drb-paper-close]');
  if (closer) {
    const modal = closer.closest('dialog');
    if (modal) modal.close();
    return;
  }

  /* Clicking the backdrop. The dialog element itself fills the viewport while
     its inner panel does not, so a click that lands ON the dialog rather than
     inside the panel is a backdrop click. */
  const dialog = event.target.closest('[data-drb-chart-modal], [data-drb-paper-modal]');
  if (dialog && event.target === dialog) dialog.close();
});

/* ============================================================================
   THE TIMELINE SEQUENCE AND THE RATIO COUNT-UP
   ============================================================================
   Mike, 2026-09-12, on the timeline: "it does all 3 but starts at 0, then works
   down to 60 with the green dot signifying which one is being filled at that
   moment." And on the ratios: "make those numbers count up from 0... the 50x
   gets there in .5sec the 2188x in 1 sec and the 3700 in 1.5 sec."

   Note what that second instruction encodes: the DURATION carries the magnitude,
   so the biggest multiplier visibly takes the longest to arrive. It is not a
   uniform animation applied to three numbers, and shortening 3,700x to match the
   others would throw away the only thing the motion is saying.

   ⚠️ NOTHING HERE IS REQUIRED FOR THE SECTION TO READ. The markup renders
   finished — full bars, done dots, final figures — and this script's first act
   is to wind it back. So a script failure, a blocked bundle or reduced motion
   all degrade to the finished state rather than to an empty one. Do not invert
   that by moving the resting state into the script.
   ============================================================================ */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const GAP_MS = 260;          /* the beat between one stage finishing and the next lighting */
  const LEAD_MS = 220;         /* a breath before the first dot lights */

  /* ---------- the ratios count up ---------- */
  const parseFigure = (raw) => {
    const n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? n : null;
  };

  /* Duration scales with the figure, which is what makes the biggest number take
     the longest: 50x lands in 500ms, 3,700x in 1500ms. Mike's three timings are
     a straight line through these, so anything he adds later gets a timing that
     matches rather than a hard-coded exception. */
  const durationFor = (n) => Math.min(1500, Math.max(500, 500 + (n / 3700) * 1000));

  const countUp = (el) => {
    const target = parseFigure(el.dataset.drbCount);
    if (target === null) return;
    const suffix = String(el.dataset.drbCount).replace(/[0-9.,]/g, '');
    const dur = durationFor(target);
    let t0 = null;

    const step = (ts) => {
      if (t0 === null) t0 = ts;
      const p = Math.min(1, (ts - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString('en-US') + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = el.dataset.drbCount;   /* land on the authored string */
    };

    el.textContent = '0' + suffix;
    requestAnimationFrame(step);
  };

  /* ---------- the timeline plays one stage at a time ---------- */
  const playSpine = (spine) => {
    const stages = Array.from(spine.querySelectorAll('[data-drb-stage]'));
    if (!stages.length) return;

    spine.classList.add('is-armed');
    stages.forEach((st) => st.classList.remove('is-active', 'is-done', 'is-filling'));
    spine.style.setProperty('--drb-spine-progress', '0%');

    const run = (i) => {
      if (i >= stages.length) return;
      const stage = stages[i];

      stage.classList.add('is-active', 'is-filling');
      spine.style.setProperty('--drb-spine-progress', Math.round(((i + 1) / stages.length) * 100) + '%');

      /* The stage is done when its SLOWEST bar is done. Both bars start together
         and run at one constant rate, so the longer bar simply takes longer —
         which is the whole point of the timing and the reason this reads the
         duration out of the DOM rather than using a fixed number per stage. */
      const ms = Array.from(stage.querySelectorAll('.drb-study__bar'))
        .reduce((max, bar) => {
          const v = parseFloat(getComputedStyle(bar).getPropertyValue('--drb-bar-ms'));
          return Number.isFinite(v) && v > max ? v : max;
        }, 0) || 800;

      window.setTimeout(() => {
        stage.classList.remove('is-active');
        stage.classList.add('is-done');
        window.setTimeout(() => run(i + 1), GAP_MS);
      }, ms);
    };

    window.setTimeout(() => run(0), LEAD_MS);
  };

  /* ---------- start each block when it is actually looked at ---------- */
  const armed = new WeakSet();

  const start = (el) => {
    if (armed.has(el)) return;
    armed.add(el);
    if (el.matches('[data-drb-spine]')) playSpine(el);
    else el.querySelectorAll('[data-drb-count]').forEach(countUp);
  };

  const init = () => {
    /* Reduced motion keeps the rendered state and never arms anything. */
    if (reduce.matches) return;

    const spines = [...document.querySelectorAll('[data-drb-spine]')];
    const stats = [...document.querySelectorAll('.drb-study__stats')];
    const targets = [...spines, ...stats];
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(start);
      return;
    }

    /* ⛔ TWO OBSERVERS, BECAUSE ONE SETTING CANNOT SERVE BOTH. This looked like
       duplication and was collapsed into a single observer once; the spine broke
       both times. The reason is geometry, not taste:

         · the stats row is SHORT — three numbers, about 120px tall. A ratio
           threshold against 120px is a small distance, so 0.55 means "a bit
           more of it is on screen".
         · the spine is TALL — the whole chart, 700px and up on a phone. The
           SAME 0.55 against 700px means nearly 400px of it has to be inside a
           band already cut to 70% of the viewport, which is most of a screenful
           of scrolling past the point where you first see it.

       So the number that reads as "deep into it" for the stats reads as "much
       too late" for the spine, which is exactly what Mike hit. */

    /* ---------- the spine: as soon as it is on screen ----------
       Mike, 2026-09-12: "that green bar takes too long to load. It should load
       almost as soon as you swipe into it." He sent the frame he wanted: the
       first node just clearing the bottom edge, rail already green.

       threshold 0 with no margin is exactly that frame — it fires on the first
       pixel of the chart entering the viewport. There is no earlier setting
       worth having; a positive bottom margin would start it while it was still
       below the fold and the top of the sequence would be over before anyone
       saw it. */
    const spineIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        spineIo.unobserve(entry.target);
        start(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px' });

    spines.forEach((t) => spineIo.observe(t));

    /* ---------- the stats: still deliberately late ----------
       Mike, earlier the same day: "make sure the counting starts only after you
       scroll to it, like deep into it, not just the second you hit the section.
       The animations hit fast so we want them to be present if you go slow
       getting down to the good stuff."

       That instruction has NOT been reversed — the message above was about the
       chart, and these are the count-ups. At threshold 0.3 with no margin they
       started while the row was a sliver at the bottom and were finished before
       a slow scroller ever read a digit. The negative bottom rootMargin pulls
       the observer's edge 30% up from the bottom of the viewport so the row has
       to be properly on screen, and 0.55 then waits until most of it is inside
       that reduced band.

       ⚠️ Do not raise the threshold much past this. The ratio is measured
       against the element's own height, so a threshold needing more of the
       element than the reduced band can hold would never fire at all and the
       numbers would silently sit at their resting state. */
    /* ⚠️ AND IT HAS TO STILL BE THERE 400ms LATER, WHICH IS THE PART THE
       GEOMETRY ALONE COULD NOT DO. Mike, 2026-09-12: "The 50x, 3,700x and
       2,188x numbers don't climb anymore... My thought is it captures that it's
       being loaded too early now so it's already ramped up by the time I get
       there. On desktop it functions perfectly still. Just mobile not perfect."

       He is right about the symptom and close on the cause. Nothing about the
       threshold changed — what changed is how he arrives. Tapping "View gastric
       study" is a SMOOTH scroll, so the row crosses the band while the page is
       still travelling, the count-up runs during the journey, and it is finished
       before the scroll settles. A phone shows this and a desktop does not,
       because the row sits close under the heading on one column and far down
       the page on two.

       An intersection is a moment; what the count-up actually wants is the row
       being LOOKED at. So the observer starts a short clock instead of firing,
       and anything that takes the row back out of the band — the rest of a
       flick, the tail of a smooth scroll that overshoots — cancels it. Arrive
       and stop, and the numbers climb from the beginning in front of you.

       ⚠️ 400ms IS A CEILING, NOT A DELAY. A jump that lands with the row already
       inside the band has usually spent most of the 400 travelling, so the climb
       starts more or less as the page settles. Raising this much further would
       start to feel like lag on an ordinary slow scroll. */
    const DWELL_MS = 400;
    const dwell = new WeakMap();

    const statsIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (dwell.has(entry.target)) return;
          dwell.set(entry.target, window.setTimeout(() => {
            dwell.delete(entry.target);
            statsIo.unobserve(entry.target);
            start(entry.target);
          }, DWELL_MS));
          return;
        }

        const pending = dwell.get(entry.target);
        if (pending) {
          window.clearTimeout(pending);
          dwell.delete(entry.target);
        }
      });
    }, { threshold: 0.55, rootMargin: '0px 0px -30% 0px' });

    stats.forEach((t) => statsIo.observe(t));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* The theme editor re-renders a section without reloading the page, so a
     freshly injected copy would otherwise sit at its resting state forever. */
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drb-testimonials"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   TAKING HOLD OF THE REVIEW BAND
   ============================================================================
   Mike, 2026-09-12: "maybe want to add left-right scroller function to this
   section as well.... We probably want the left-right scrolls to all feel the
   same on the website wherever possible."

   ⚠️ THIS DOES NOT ADD A SECOND MECHANISM, IT PROMOTES THE ONE ALREADY HERE.
   The band is a CSS marquee: a duplicated track on a composited transform, no
   script, no rAF. Under prefers-reduced-motion it was already becoming a plain
   horizontal scroller. Touching an arrow or dragging now does exactly that same
   thing, permanently. So there is one manual mode, defined once in the CSS, and
   two ways into it.

   ⚠️ THE SWITCH USED TO BE ONE WAY, ON THE REASONING THAT HANDING THE BAND BACK
   WOULD SLIDE THE QUOTE OUT FROM UNDER A READER. Mike, 2026-09-12: "after you
   touch it to scroll anyway at all it never starts scrolling on its own again."

   The reasoning was not wrong, it was incomplete: it only covered the person
   still reading. The commoner case is the person who nudged the band on the way
   past and left a dead strip on the page for the rest of the visit. So the band
   comes back after RESUME_MS of no contact, and the reader is protected by the
   clock and the hover check instead of by never returning at all.
   ============================================================================ */
(() => {
  /* ⚠️ THE HAND-OFF IS THE WHOLE TRICK. The marquee lives on a transform and the
     scroller lives on scrollLeft, so flipping between them naively snaps the
     band back to the first quote — jarring, and it throws away whatever the
     reader was in the middle of.

     Reading the animated transform off the computed style and writing it into
     scrollLeft makes the swap invisible. getComputedStyle resolves an in-flight
     animation to its CURRENT matrix, which is exactly the number needed. */
  const currentOffset = (track) => {
    const t = getComputedStyle(track).transform;
    if (!t || t === 'none') return 0;
    const m = t.match(/matrix.*\((.+)\)/);
    if (!m) return 0;
    const parts = m[1].split(',').map((n) => parseFloat(n));
    /* matrix() puts translateX at index 4, matrix3d() at 12. */
    const x = parts.length === 6 ? parts[4] : parts[12];
    return Number.isFinite(x) ? -x : 0;
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* How long the band waits, untouched, before it starts moving on its own
     again. Long enough to read a whole quote twice; short enough that a band
     someone brushed past does not stay frozen for the rest of the visit. The
     doctors row uses the same idea at 15s, but that one is a swap and this one
     is a slow crawl, so it can come back sooner.

     ⚠️ 9s FELT LIKE IT HAD STOPPED. Mike, 2026-09-12: "would just like to see it
     begin scrolling again a little faster. Maybe 2.5 or 3 seconds." The reason
     the short number is safe here and would not be on the doctors row is the
     seam: this band re-enters mid-cycle and crawls, so nothing jumps and nobody
     loses their place. It is only ever the band deciding to move again. */
  const RESUME_MS = 3000;

  const state = new WeakMap();
  const stateOf = (root) => {
    let st = state.get(root);
    if (!st) {
      st = { ms: 0, timer: null, hover: false };
      state.set(root, st);
    }
    return st;
  };

  /* The marquee's duration, read off the running animation. It has to be taken
     while the marquee is still live — in manual mode the animation is `none`
     and there is nothing to read — and it is what the resume needs to work out
     where in the loop to re-enter. */
  const durationOf = (track) => {
    const d = getComputedStyle(track).animationDuration || '';
    const n = parseFloat(d);
    if (!Number.isFinite(n) || n <= 0) return 60000;
    return /ms\s*$/.test(d) ? n : n * 1000;
  };

  const armResume = (root) => {
    const st = stateOf(root);
    if (st.timer) window.clearTimeout(st.timer);
    st.timer = null;
    /* ⛔ NEVER FOR REDUCED MOTION. An infinite marquee is a vestibular trigger,
       and for those visitors the band is a plain scroller by design — handing
       it back would undo the one accommodation this section makes. */
    if (reduceMotion.matches) return;
    st.timer = window.setTimeout(() => {
      st.timer = null;
      /* Still under the pointer: wait again rather than pulling the quote out
         from under someone who is reading it. */
      if (st.hover) {
        armResume(root);
        return;
      }
      resume(root);
    }, RESUME_MS);
  };

  const goManual = (root) => {
    const section = root.closest('.drb-testis');
    if (!section) return;

    const viewport = root.querySelector('.drb-testis__viewport');
    const track = root.querySelector('.drb-testis__track');
    if (!viewport || !track) return;

    if (section.dataset.drbManual !== 'true') {
      const st = stateOf(root);
      if (!st.ms) st.ms = durationOf(track);

      const offset = currentOffset(track);
      section.dataset.drbManual = 'true';
      section.classList.add('drb-testis--manual');

      /* Set the scroll position in the same frame the class lands, so the band
         never paints at zero.

         ⚠️ DO NOT CLEAR track.style.animationDelay HERE. A resume leaves a
         negative delay behind, and wiping it while the marquee is still the
         thing on screen restarts the animation at phase zero for one frame —
         the band snaps back to the first quote and then the class lands. The
         next resume overwrites it anyway. */
      viewport.scrollLeft = offset;
    }

    armResume(root);
  };

  /* ---------- back to the marquee ----------
     Mike, 2026-09-12: "after you touch it to scroll anyway at all it never
     starts scrolling on its own again."

     ⚠️ THE SEAM IS THE WHOLE JOB, AND IT IS THE SAME TRICK AS THE HAND-OFF IN
     THE OTHER DIRECTION, RUN BACKWARDS. The marquee is a transform from 0 to
     -50% of a two-group track; manual mode is scrollLeft on the same track. One
     group is therefore exactly one full cycle, so a scroll position of S sits at
     phase (S mod G) / G of the animation.

     Feed that phase back as a NEGATIVE animation-delay and the animation starts
     mid-cycle, already at the offset the reader left it at, and the swap is
     invisible. Drop the delay and the band jumps to the first quote — which is
     the carousel behaviour this whole section was written to avoid. */
  const resume = (root) => {
    const section = root.closest('.drb-testis');
    if (!section || section.dataset.drbManual !== 'true') return;

    const viewport = root.querySelector('.drb-testis__viewport');
    const track = root.querySelector('.drb-testis__track');
    if (!viewport || !track) return;

    const st = stateOf(root);
    /* Two identical halves, so half the track is one cycle. This is only true
       because manual mode now KEEPS the duplicate group — see the CSS. */
    const group = track.scrollWidth / 2;
    const ms = st.ms || durationOf(track);

    if (group > 0) {
      const phase = (((viewport.scrollLeft % group) + group) % group) / group;
      track.style.animationDelay = '-' + Math.round(phase * ms) + 'ms';
    }

    section.dataset.drbManual = 'false';
    section.classList.remove('drb-testis--manual');
    /* The transform takes over from here, so the scroller's own offset has to
       go back to zero in the same frame or the two would compound. */
    viewport.scrollLeft = 0;
  };

  const step = (viewport) => {
    const card = viewport.querySelector('.drb-testi');
    /* One card plus its margin, or a sensible slice of the viewport if the
       cards have not laid out yet. */
    if (!card) return Math.round(viewport.clientWidth * 0.8);
    const rect = card.getBoundingClientRect();
    const gap = parseFloat(getComputedStyle(card).marginRight) || 0;
    return Math.round(rect.width + gap);
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-drb-revs-prev], [data-drb-revs-next]');
    if (!arrow) return;
    const root = arrow.closest('[data-drb-revs]');
    if (!root) return;

    goManual(root);

    const viewport = root.querySelector('.drb-testis__viewport');
    if (!viewport) return;
    const dir = arrow.hasAttribute('data-drb-revs-next') ? 1 : -1;
    viewport.scrollBy({ left: dir * step(viewport), behavior: 'smooth' });
  });

  /* Hovering already pauses the marquee in CSS; this is the same idea for the
     resume timer, so the band cannot restart under a resting mouse. */
  document.addEventListener('pointerover', (event) => {
    const root = event.target.closest && event.target.closest('[data-drb-revs]');
    if (!root || event.pointerType === 'touch') return;
    stateOf(root).hover = true;
  });

  document.addEventListener('pointerout', (event) => {
    const root = event.target.closest && event.target.closest('[data-drb-revs]');
    if (!root || event.pointerType === 'touch') return;
    if (event.relatedTarget && root.contains(event.relatedTarget)) return;
    stateOf(root).hover = false;
  });

  /* ---------- drag ----------
     Touch scrolling comes free once the viewport is overflow-x: auto, but only
     AFTER the switch — so a touch drag has to promote the band first, which the
     pointerdown below does for every pointer type.

     ⚠️ A mouse cannot drag a scroll container natively, so that part is manual:
     hold the pointer, move it, and scrollLeft follows. The 4px threshold is what
     keeps an ordinary click on a quote from being read as a drag. */
  let drag = null;

  document.addEventListener('pointerdown', (event) => {
    const root = event.target.closest('[data-drb-revs]');
    if (!root) return;
    if (event.target.closest('button, a')) return;

    const viewport = root.querySelector('.drb-testis__viewport');
    if (!viewport) return;

    drag = { root, viewport, x: event.clientX, from: 0, moved: false, id: event.pointerId };
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 4) return;
      drag.moved = true;
      goManual(drag.root);
      drag.from = drag.viewport.scrollLeft;
      /* ⚠️ SCROLL SNAPPING IS WHAT MADE THE MOUSE DRAG JUDDER, AND IT IS ONLY
         EVER A MOUSE PROBLEM. Mike, 2026-09-12: "On mobile the left right
         slider with the finger slide is great... On desktop not so much. It
         jumps and doesn't slide smoothly."

         A finger drag is a native gesture: the browser knows the gesture is
         still in progress and holds the snap until the finger lifts. A mouse
         drag is us writing scrollLeft, and every one of those writes looks to
         the browser like a finished programmatic scroll — so it snaps to the
         nearest card, on every pointermove, against the direction of travel.

         The class turns snapping off for the duration of the drag and endDrag
         puts it back, so the release still settles on a card. */
      drag.root.classList.add('drb-testis--dragging');
      drag.viewport.style.userSelect = 'none';
      drag.viewport.style.cursor = 'grabbing';
    }

    let next = drag.from - dx;

    /* ⚠️ AND THE DRAG IS ENDLESS, BECAUSE THE TRACK STILL HAS BOTH HALVES.
       Without this the band hits a hard wall at the end of the duplicate and
       stops dead, which is a worse answer than the marquee it replaced. Moving
       the anchor by the same amount as the position keeps the card under the
       finger exactly where it was. */
    const group = drag.viewport.scrollWidth / 2;
    if (group > 0) {
      while (next >= group) {
        next -= group;
        drag.from -= group;
      }
      while (next < 0) {
        next += group;
        drag.from += group;
      }
    }

    drag.viewport.scrollLeft = next;
    if (event.cancelable) event.preventDefault();
  });

  const endDrag = () => {
    if (!drag) return;
    drag.root.classList.remove('drb-testis--dragging');
    drag.viewport.style.userSelect = '';
    drag.viewport.style.cursor = '';
    /* Restart the clock from the end of the gesture, not from its start. */
    if (drag.moved) armResume(drag.root);
    drag = null;
  };

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
